<template>
    <div class="news-page h-full">
        <vue-headful :title="$t('news')" />

        <div class="flex mb-5" v-if="user && user.role.is_columnist">
            <vs-button class="w-full lg:w-auto" color="primary" @click="$store.commit('news_columnist/SET_NEWS_POPUP', true)" type="filled">{{$t('add_news')}}</vs-button>
        </div>

        <!-- БЛОК ПРИВЕТСТВИЯ -->
        <h4 v-if="user" class="hello_title mb-6">{{$t('welcome')}} {{user.firstName}}!</h4>

        <!-- СРОЧНЫЕ НОВОСТИ -->
        <div class="news_important_container mb-8" v-if="importantNews.length">
            <div v-show="loading" class="loader_container vs-con-loading__container"></div>
            <div :class="['news_important_grid', importantNews.length == 2 && 'two_news', importantNews.length == 3 && 'three_news']">
                <div class="news_item" v-for="(item, index) in importantNews" :key="`important_${index}`">
                    <ImportantCard :item="item" :index="index" />
                </div>
            </div>
            <div v-if="totalPage > 1" class="mt-3 important_pagination">
                <vs-pagination :description="true" class="w-full" :total="totalPage" :max="6" v-model="currentPage"></vs-pagination>
            </div>
        </div>

        <!-- НОВОСТИ -->
        <div class="items-grid-view vx-row match-height">
            <div class="vx-col lg:w-1/2 sm:w-1/2 w-full" v-for="(item, index) in regularNews" :key="`regular_${index}`">
                <RegularCard :item="item" />
            </div>

            <!-- handler для инфинити скролла -->
            <infinite-loading class="vx-col w-full" spinner="spiral" v-bind:distance="500" @infinite="infiniteHandler">
                <!-- Если новостей больше нет показываем сообщение -->
                <div slot="no-more">
                    <div class="con-vs-alert con-vs-alert-primary">
                        <div class="vs-alert">{{$t('no_more_news')}}</div>
                    </div>
                </div>
                <!-- Если новостей вообще нет показываем сообщение -->
                <div slot="no-results">
                    <div class="con-vs-alert con-vs-alert-primary">
                        <div class="vs-alert">{{$t('no_more_news')}}</div>
                    </div>
                </div>
            </infinite-loading>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex"

import RegularCard from "@/pages/Home/News/components/RegularCard"
import ImportantCard from "@/pages/Home/News/components/ImportantCard"

import InfiniteLoading from 'vue-infinite-loading'
import 'lazysizes'

export default {
    name: "NewsPage",
    data() {
        return {
            page: 0,
            loading: false,
            infiniteLoad: false
        }
    },
    components: {
        RegularCard,
        ImportantCard,
        InfiniteLoading
    },
    created() {
        if(this.currPage === 0)
            this.currentPage = 1
    },
    beforeDestroy () {
        // При покидании компонента очищаем все данные новости, если не очищать при входе под другим пользователем он видит новости предыдущего пользователя
        this.currentPage = 0
        this.newsStatus = true
        this.page = 0
        this.$store.commit('news/CLEAR_ALL_NEWS')
    },
    methods: {

        async restartPage(){

            try {
                this.loading = true
                await  this.$store.commit('news/CLEAR_ALL_NEWS')
                await  this.$store.commit('news/SET_CURRENT_PAGE',1)
                this.getNews = await this.$store.dispatch('news/getNews');
                this.getImportantNews = await this.$store.dispatch('news/getImportantNews');
                await this.$forceUpdate();

            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } 
            finally {
                this.loading = false
            }

        },
        ...mapActions({
            getNews: 'news/getNews',
            getImportantNews: 'news/getImportantNews'
        }),
        async newsImportant() {
            // Получаем список срочных новостей
            try {
                this.loading = true
                await this.getImportantNews()
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.loading = false
            }
        },
        async infiniteHandler($state) {
            // Событие при прикрутке, получаем список новостей для указанной страницы
            // если newsStatus = false останавливаем бесконечную прокрутку
            if(this.newsStatus) {
                try {
                    this.page = this.page + 1
                    const res = await this.getNews({page: this.page})

                    if(!res || this.regularNews.length >= this.regularNewsCount) {
                        // Если новостей больше нет, останавалием бесконечную прогрузку
                        $state.complete();
                        this.newsStatus = false
                    } else {
                        if($state) $state.loaded();
                    }
                } catch(e) {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger'
                    })
                }
            }
        }
    },

    watch:{
        is_reload(val){
            if(val === true){
                try{
                    this.restartPage()
                    this.$store.commit('news_columnist/SET_RELOAD_PAGE', false);

                }catch{
                    this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
                }
            }
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            regularNews: state => state.news.regularNews,
            regularNewsCount: state => state.news.regularNewsCount,
            importantNews: state => state.news.importantNews,
            totalPage: state => state.news.totalPage,
            currPage: state => state.news.currentPage
        }),


        ...mapGetters({
            is_reload:'news_columnist/MakeReloadNewsPage',
        }),

        currentPage: {
            // Пагинация для срочных новостей
            get() {
                return this.currPage
            },
            set(value) {
                // Обновляем пагинацию если выбранная страница не равно текущей, и выбранная страница больше 0
                if(this.currPage !== value && value) {
                    this.$store.commit("news/SET_CURRENT_PAGE", value);
                    this.newsImportant()
                }
            }
        },
        newsStatus: {
            // Статус для инфинити скрола
            get() {
                return this.$store.state.news.regularNewsStatus
            },
            set(value) {
                this.$store.commit("news/SET_NEWS_STATUS", value);
            }
        }
    }
}
</script>

<style lang="scss">
.items-grid-view{
    .infinite-status-prompt{
        width: 100%;
    }
}
.loader_container,
#news_loader{
    padding: 20px 0;
}
.important_pagination{
    .vs-col{
        &:first-child{
            div{
                display: none!important;
            }
        }
    }
}
.news_important_container{
    min-height: 200px;
    position: relative;
    .loader_container{
        position: absolute;
        z-index: 10;
        width: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        .con-vs-loading{
            position: absolute;
        }
    }
    .news_important_grid{
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
        grid-template-rows: repeat(2, 240px);
        grid-gap: 30px;
        grid-auto-flow: dense;
        .news_item{
            &:first-child{
                grid-column: span 2;
                grid-row: span 2;
            }
            .vs-button-primary{
                border: 1px solid #ffffff!important;
                color: #ffffff;
            }
        }
        &.two_news{
            grid-template-rows: repeat(1, 280px);
                .news_item{
                    &:first-child{
                    grid-column: initial;
                    grid-row: initial;
                }
            }
        }
        &.three_news{
            grid-template-rows: repeat(1, 280px);
                .news_item{
                    &:first-child{
                    grid-row: initial;
                }
            }
        }
    }
}
@media only screen and (max-width: 1850px) {
    .news_important_container{
        .news_important_grid{
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        }
    }
}
@media only screen and (max-width: 1700px) {
    .news_important_container{
        .news_important_grid{
            grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
        }
    }
}
@media only screen and (max-width: 1160px) {
    .news_important_container{
        .news_important_grid{
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        }
    }
}
@media only screen and (max-width: 900px) {
    .hello_title{
        font-size: 15px;
    }
    .news_important_container{
        min-height: 50px;
        .important_pagination{
            .vs-col{
                justify-content: center;
            }
        }
        .news_important_grid{
            display: block;
            .news_item{
                &:not(:last-child){
                    margin-bottom: 10px;
                }
                .vs-button-primary{
                    display: none;
                }
            }
        }
    }
}
</style>
